import Base from '../base';
import apiUrls from '../api-urls';

export default class ConfigAPI extends Base {
    async get(data) {
        return this.apiClient.post(apiUrls.global.config, data);
    }

    async getMiniBanners(data) {
        return this.apiClient.post(apiUrls.global.miniBanners, data);
    }

    // DB-backed translation dictionary for the current language (resolved from the lang cookie).
    async getTranslations(data = {}) {
        return this.apiClient.post(apiUrls.global.translations, data);
    }

    // Dev / doruk.tech: upsert keys that were missing from the loaded dictionary.
    async pushMissingTranslations(data = {}) {
        return this.apiClient.post(apiUrls.global.translationsMissing, data);
    }

    async changeLanguage(data) {
        return this.apiClient.post(apiUrls.global.language, data);
    }

    async getSignupDefaults(data = {}) {
        return this.apiClient.post(apiUrls.global.signupDefaults, data);
    }
}
